import { Bone } from '../primitives';

// Matches InstantVoiceClone.tsx's 2-column layout: a step-indicator card on the left,
// a large step-content card on the right.
export default function InstantVoiceCloneSkeleton() {
    return (
        <div className="row g-4">
            <div className="col-12 col-lg-3">
                <div style={{ border: '1px solid #E2E8F0', borderRadius: 13, padding: 20 }}>
                    <Bone h={11} w={80} style={{ marginBottom: 16 }} />
                    <Bone h={40} w="100%" style={{ marginBottom: 10 }} />
                    <Bone h={40} w="100%" />
                </div>
            </div>
            <div className="col-12 col-lg-9">
                <div style={{ border: '1px solid #E2E8F0', borderRadius: 13, padding: 20, minHeight: 320 }}>
                    <Bone h={16} w={200} style={{ marginBottom: 20 }} />
                    <Bone h={220} r={10} />
                </div>
            </div>
        </div>
    );
}
